// extracted by mini-css-extract-plugin
export default {"container":"EnergyPolicyPage_container__AkDpb"};